import { useContext } from "react";
import { dataContext } from "../../context/context";
import './footer.css';
import logo from "../../assets/images/logo.svg";

function Footer() {

    const { data, loading, error, isBY  } = useContext(dataContext);


    return (
        <footer>
            <h2>Международная сеть ресторанов со службой доставки</h2>
            <div className="footer__inner">

                <div className="logo"><a href={isBY ? "https://sushi-tunec.by" : "https://sushi-tunec.ru"}><img alt="Франшиза Суши бар Тунец" src={logo} /></a></div>

                {  (data && !loading && !error) && (

                <ul>

                    {
                    data.variablesdata.filter(variable => variable.var === 'phone').map((phone, index) => (
                    <li key={index}><a key={index} href={`tel: ${phone.clearedval}`}>{phone.val}</a></li>
                    ))
                    }


                    {
                    data.variablesdata.filter(variable => variable.var === 'email').map((email, index) => (
                    <li key={index}><a key={index} href={`mailto: ${email.val}`}>{email.val}</a></li>
                        ))
                    }

                </ul>

                )}

            </div>


        </footer>
    )
}

export default Footer